<template>
	<TwoColumns
		first-column-class="contained-section"
		second-column-class="contained-section"
	>
		<template #first>
			<h2>Our mission</h2>
			<div class="text-lg text-gray-575">
				<div>
					Our mission is to facilitate the transition to safer and
					more sustainable mobility. Founded in 2016, we aim to be the
					world’s most trusted automotive retailer by offering better
					ways to access, assess and manage a car.
				</div>
			</div>
			<CarbarImage
				image="img/about-us/img-mission.webp"
				alt-text="Carbar mission"
			/>
		</template>
		<template #second>
			<h2 class="w-full lg:w-1/2">Our values</h2>
			<div v-for="(list, key) in Lists" :key="key">
				<div class="text-xl font-medium text-gray-700">
					{{ list.head }}
				</div>
				<div class="mb-7 mt-3 text-lg text-gray-575">
					{{ list.content }}
				</div>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'

const props = defineProps({
	icon: {
		type: String,
		default: 'img/common/ico-arrow_down.svg',
		required: false,
	},
})

const Lists = [
	{
		head: 'Adventurous',
		content:
			'We challenge established systems and beliefs and find new ways to grow our company and each other',
	},
	{
		head: 'Simplicity',
		content:
			'We use technology and each other to make what looks difficult easy - it’s our job to demystify and simplify car ownership',
	},
	{
		head: 'Inclusive',
		content:
			'We leverage the collective genius, connect with customers and each other with transparency, dignity and respect',
	},
	{
		head: 'Accountable',
		content:
			'We deliver our very best in everything we do and hold ourselves accountable for results',
	},
	{
		head: 'Loyal',
		content:
			'We focus on the customer and our staff - when they’re are happy with our service, our business is growing',
	},
]
</script>
